import { render, staticRenderFns } from "./CompanyPersonalizationCard.vue?vue&type=template&id=96c11ed4&scoped=true&"
import script from "./CompanyPersonalizationCard.vue?vue&type=script&lang=js&"
export * from "./CompanyPersonalizationCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPersonalizationCard.vue?vue&type=style&index=0&id=96c11ed4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c11ed4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VExpandTransition,VIcon})
